import { AddressTypeEnum } from "@lib/enum"
import { CustomerPotentialModel } from "@models/customer/customerPotentialModel"
import dayjs from "dayjs"

export class BookingModel {
  id: any
  customers?: any[]
  constructor() {
    this.id = undefined
    this.customers = []
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new BookingModel(), obj)

    newObj.bookingDate = obj.bookingDate ? dayjs(obj.bookingDate) : null
    newObj.expiredDate = obj.expiredDate ? dayjs(obj.expiredDate) : null

    newObj.projectId = obj.projectId ?? obj.cart?.projectId

    newObj.customers = obj.customers?.map((item) => {
      return { ...CustomerPotentialModel.assign(item) }
    }) // CustomerModel.assigns(obj.customers)
    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class BookingUpdateModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new BookingUpdateModel(), obj)

    newObj.customers = obj.customers.map((item) => {
      return {
        ...item,
        customerAddresses: [
          { addressType: AddressTypeEnum.CURRENT, ...obj.currentAddress },
          { addressType: AddressTypeEnum.PERMANENT, ...obj.permanentAddress },
        ],
      }
    })

    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
